/* eslint camelcase: 0 */
import { AlgoliaGatewayBase } from './base'
import { toHits, toQueryProps } from './translator/query'
import { toHospitalProps } from '@/gateways/Monitaro/translator/hospital'
import { FetchHospital } from '@/infrastructure/network/Algolia/requests/hospital'
import { IQueryProps } from '@/entities/Query'

export default class Hospital extends AlgoliaGatewayBase {
  async clearCache() {
    await this.apiClient.clearCache(new FetchHospital().index)
  }

  async FetchHospital(query: IQueryProps) {
    const response = await this.apiClient.request(new FetchHospital(query.word, toHits(query)))
    return {
      items: response.hits!.map((prop) => toHospitalProps(prop)),
      query: toQueryProps(response)
    }
  }
}
